// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiXTdhGrant } from '../models/ApiXTdhGrant';
import { HttpFile } from '../http/http';

export class ApiXTdhContribution {
    'grant'?: ApiXTdhGrant;
    'grantor'?: ApiProfileMin;
    'xtdh': number;
    'xtdh_rate': number;
    'total_grant_count'?: number;
    'active_grant_count'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "grant",
            "baseName": "grant",
            "type": "ApiXTdhGrant",
            "format": ""
        },
        {
            "name": "grantor",
            "baseName": "grantor",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "float"
        },
        {
            "name": "xtdh_rate",
            "baseName": "xtdh_rate",
            "type": "number",
            "format": "float"
        },
        {
            "name": "total_grant_count",
            "baseName": "total_grant_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "active_grant_count",
            "baseName": "active_grant_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiXTdhContribution.attributeTypeMap;
    }

    public constructor() {
    }
}
